import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=39f03e24&lang=pug&"
import script from "./Campaigns.vue?vue&type=script&lang=js&"
export * from "./Campaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f03e24')) {
      api.createRecord('39f03e24', component.options)
    } else {
      api.reload('39f03e24', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=39f03e24&lang=pug&", function () {
      api.rerender('39f03e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/campaigns/Campaigns.vue"
export default component.exports